/**
 * Batch naming shown and used when creating a student or a batch.
 * Generated names stay Batch-1, Batch-2, … per course.
 */

export const BATCH_NAMING_HELP =
  'New batches are named Batch-1, Batch-2, and so on for that course.';

export function formatStandardBatchName(sequence) {
  const n = Math.max(1, parseInt(sequence, 10) || 1);
  return `Batch-${n}`;
}

export function parseBatchSequence(batchName) {
  const match = String(batchName || '').match(/Batch-(\d+)$/i);
  if (!match) return null;
  const n = parseInt(match[1], 10);
  return Number.isNaN(n) ? null : n;
}

export function maxBatchSequence(batches) {
  let max = 0;
  for (const batch of batches || []) {
    const seq = parseBatchSequence(batch?.batchName);
    if (seq != null) max = Math.max(max, seq);
  }
  return max;
}

export function suggestNextBatchName(courseBatches) {
  return formatStandardBatchName(maxBatchSequence(courseBatches) + 1);
}

export function batchesForCourse(batches, courseId) {
  const id = String(courseId || '').trim();
  if (!id) return [];
  return (batches || []).filter((batch) => String(batch?.courseId ?? batch?.course?.id) === id);
}
